import {Component} from 'preact';

const BADGE_MAP = {
    bronze: 'solid-bronze',
    silver: 'solid-silver',
    gold: 'solid-gold',
    platinum: 'solid-platinum'
};


class UEStatusBadge extends Component {
    static defaultProps = {
        currentRank: null // oneOf(['bronze','silver','gold','platinum])
    };

    render ( {currentRank} ) {
        const status = currentRank?.toLowerCase();
        const imgSrc = BADGE_MAP[status] || 'none';
        return (
            <img data-testid="UEStatusBadge" className="currentStatusImage" src={`/svg/components/upi-rewards/ue-status-${imgSrc}.svg`} />
        );
    }
}

export default UEStatusBadge;
